export const SELL_HUB_EVENTS = {
  MAIN: 'sellHub',
  LOADED: 'sellHub.loaded',
  SEARCH_RESULTS: 'sellHub.searchResults',
  ERROR: 'sellHub.error'
};

export const SELL_FLOW_EVENTS = {
  MAIN: 'sellflow',
  LISTING_DETAILS_LOADED: 'sellflow.listing_details_loaded',
  LISTING_CREATED: 'sellflow.listing_created',
  ACCOUNT_DETAILS: 'sellflow.account_details',
  ADD_TICKET_DETAILS: 'sellflow.add_ticket_details',
  ADD_SELLER_TYPE: 'sellHub.addSellerType',
  ADD_FULFILLMENT: 'sellHub.addFulfillment',
  ADD_PRICE: 'sellHub.addPrice'
};

export const SELL_CHATBOT_EVENTS = {
  MAIN: 'chatbot',
  OPEN: 'chatbot.open',
  CLOSE: 'chatbot.close',
};
